module.exports = __webpack_public_path__ + "static/img/banner_mobile.8f76738.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_mobile.jpg
// module id = 9CXY
// module chunks = 1